import React, {useState} from 'react'
import {Input, message, Tag} from "antd";
import {updateTenantHub} from "../../../../../../services/api/apiCustomerHub";
import parseToken from "../../../../../../helpers/parseToken";
import {formatNumber} from "../../../../../shared/Contants";
import checkRole from "../../../../../../helpers/checkRole";
import HistoryFeeModal from "./HistoryFeeModal"

const BlockTop = (props) => {
    const {customerInformation, fetchCustomerDetail, custId, setCustomerInformation} = props
    const [isEdit, setIsEdit] = useState(false)
    const [loading, setLoading] = useState(false)
    const decodeToken = parseToken()

    const toggleEdit = async () => {
        if (isEdit) {
            await fetchCustomerDetail()
        } else {
            await setCustomerInformation({
                ...customerInformation,
                billingBalance: ''
            })
        }
        setIsEdit(!isEdit)
    }

    const onChangeInput = (e) => {
        const {value} = e.target
        setCustomerInformation({
            ...customerInformation,
            billingBalance: value
        })
    }

    const onKeyPressInput = (e) => {
        if (e.key === 'Enter') {
            onUpdate()
        }
    }

    const onUpdate = async () => {
        try {
            setLoading(true)
            const payload = {
                billingBalance: customerInformation.billingBalance,
                id: custId
            }
            const response = await updateTenantHub(decodeToken.sub, payload)
            setLoading(false)
            setIsEdit(false)
            const {success, error_message} = response
            if (success !== '1') {
                return message.error(error_message)
            }
            fetchCustomerDetail()
            message.success('Update thành công!')
        } catch (e) {
            fetchCustomerDetail()
            setLoading(false)
            message.error(e.message)
        }
    }

    const mapType = (value) => {
        return value === 'Trả sau' ? <Tag color="#87d068">{value}</Tag> : <Tag color="#108ee9">{value}</Tag>
    }

    return (
        <>
            <div className="Item">
                <div className="Title">Tên khách hàng</div>
                <div className="Content">{customerInformation.tenantFullName || ''}</div>
            </div>
            <div className="Item">
                <div className="Title">Mã số thuế</div>
                <div className="Content">{customerInformation.tax || ''}</div>
            </div>
            <div className="Item">
                <div className="Title">Điện thoại liên hệ</div>
                <div className="Content">{customerInformation.phoneNumber || ''}</div>
            </div>
            <div className="Item">
                <div className="Title">Email</div>
                <div className="Content">{customerInformation.email || ''}</div>
            </div>
            <div className="Item">
                <div className="Title">Hình thức</div>
                <div className="Content">{mapType(customerInformation?.billingPamentType)}</div>
            </div>
            <div className="Item">
                <div className="Title">Hạn mức</div>
                {checkRole('menu.customerhub.editCustomer') ? (
                    <div className="Content">
                        {isEdit ?
                            <div className="d-flex align-items-center">
                                <Input
                                    type="number"
                                    onKeyPress={onKeyPressInput}
                                    disabled={loading}
                                    onChange={onChangeInput}
                                    value={customerInformation.billingBalance}
                                />
                                <span
                                    className="material-icons cursor-pointer text-primary"
                                    onClick={onUpdate}
                                >check</span>
                                <span
                                    className="material-icons cursor-pointer text-danger"
                                    onClick={toggleEdit}
                                >close</span>
                            </div> :
                            customerInformation.billingBalance ? formatNumber(parseInt(customerInformation.billingBalance), 0, 3, '.', ',') : customerInformation?.billingBalance ? formatNumber(parseInt(customerInformation?.billingBalance), 0, 3, '.', ',') : 0}
                        {
                            /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
                            !isEdit && <a className="icon" rel="noreferrer">
                                <span className="material-icons cursor-pointer" onClick={toggleEdit}>border_color</span>
                            </a>
                        }
                    </div>
                ) : (
                    <div className="Content">
                        {customerInformation.billingBalance ? formatNumber(parseInt(customerInformation.billingBalance), 0, 3, '.', ',') : customerInformation?.billingBalance ? formatNumber(parseInt(customerInformation?.billingBalance), 0, 3, '.', ',') : 0}
                    </div>
                )}
            </div>
            {checkRole('menu.customerhub.topUpHistory') && <div className="Item">
                <div className="Title">Lịch sử nạp cước</div>
                <div className="Content">
                    <HistoryFeeModal custId={custId}/>
                </div>
            </div>}
        </>
    )
}

export default BlockTop
